import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import sum from 'lodash/sum'

import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import BondedUnbondedTicketsPieChart from './BondedUnbondedTicketsPieChart'
import BondedUnbondedTicketsChart from './BondedUnbondedTicketsChart'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import IconLink from 'components/Shared/IconLink/Index'

const StyledContent = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  box-sizing: border-box;
  border-radius: 3px;
  flex-direction: column;
  margin-right: 8px;
  background-color: #fff;
  padding: 10px 16px 10px 16px;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  color: ${colors.secondary20};
`

const ChartsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  ${props => props.hideTicketsChart && css`
    align-self: center;
  `}
`

const BondedUnbondedChart = ({
  isSummaryTab, userTimeZoneAbbr, userTimeFormat24,
  bondedUnbondedTickets, recentUnbondedTicketsCount, recentBondedTicketsCount,
  fetchingBondedUnbonded, fetchingRecentBondedUnbonded,
}) => {
  const { t } = useTranslation()

  const loading = fetchingRecentBondedUnbonded || fetchingBondedUnbonded

  const tooltipText = t('dashboardPage.bondedVsUnbondedTooltip')
  const tooltipId = 'bonded-unbonded-tooltip'

  const bondedTimeDependsData = bondedUnbondedTickets.find(i => i.name === 'bonded')
  const unbondedTimeDependsData = bondedUnbondedTickets.find(i => i.name === 'unbonded')
  const bondedTimeDepends = bondedTimeDependsData ? sum(bondedTimeDependsData.data) : 0
  const unbondedTimeDepends = unbondedTimeDependsData ? sum(unbondedTimeDependsData.data) : 0

  return (
    <StyledContent data-test='bonded-unbonded-chart'>
      <LoadingIndicator loading={loading} small />
      <Title>
        {t('dashboardPage.bondedVsUnbonded')}
        {isSummaryTab && (
          <>
            <IconLink
              data-tooltip-content={tooltipText}
              data-tooltip-id={tooltipId}
              iconName='icon-help-16'
            />
            <Tooltip id='bonded-unbonded-tooltip' />
          </>
        )}
      </Title>
      <ChartsWrapper hideTicketsChart={isSummaryTab}>
        <BondedUnbondedTicketsPieChart
          recentUnbondedTicketsCount={isSummaryTab ? recentUnbondedTicketsCount : unbondedTimeDepends}
          recentBondedTicketsCount={isSummaryTab ? recentBondedTicketsCount : bondedTimeDepends}
        />

        {!isSummaryTab && (
          <BondedUnbondedTicketsChart
            bondedUnbondedTickets={bondedUnbondedTickets}
            userTimeZoneAbbr={userTimeZoneAbbr}
            userTimeFormat24={userTimeFormat24}
          />
        )}
      </ChartsWrapper>
    </StyledContent>
  )
}


BondedUnbondedChart.propTypes = {
  isSummaryTab: PropTypes.bool,
  userTimeZoneAbbr: PropTypes.string,
  userTimeFormat24: PropTypes.bool,
  bondedUnbondedTickets: PropTypes.array,
  recentUnbondedTicketsCount: PropTypes.number,
  recentBondedTicketsCount: PropTypes.number,
  fetchingBondedUnbonded: PropTypes.bool,
  fetchingRecentBondedUnbonded: PropTypes.bool,
}

export default BondedUnbondedChart
